module.exports = __webpack_public_path__ + "media/images/pic/popup/popup-desktop-final-52b8abce2755894e3beeae41fcbd92ad.jpg";